import { GENERIC_NETWORK_FETCH_MESSAGES } from "@/lib/networkFetchError";

import type { CaptureResult } from "posthog-js";

interface ExceptionListItem {
  type?: string;
  value?: string;
  stacktrace?: { frames?: unknown[] };
}

/**
 * Drops unhandled Safari/WebKit `fetch()` failures that have no JS stack.
 * PostHog groups these as TypeError "Load failed" (ASA-1507). Keep events that
 * already have frames so real application errors still reach Error Tracking.
 */
export function dropGenericSafariFetchExceptions(event: CaptureResult | null): CaptureResult | null {
  if (!event || event.event !== "$exception") {
    return event;
  }

  const list = event.properties?.$exception_list;
  if (!Array.isArray(list) || list.length === 0) {
    return event;
  }

  const first = list[0] as ExceptionListItem;
  const value = typeof first.value === "string" ? first.value.trim() : "";
  if (!GENERIC_NETWORK_FETCH_MESSAGES.includes(value)) {
    return event;
  }

  const frames = first.stacktrace?.frames;
  if (Array.isArray(frames) && frames.length > 0) {
    return event;
  }

  return null;
}
